import React from 'react';
import ShortId from 'shortid';
import PropTypes from 'prop-types';
import HeadingActions from '../../components/HeadingActions';

export const PageLinks = props => {
  return (
    <HeadingActions
      isTransportation={props.isTransportation}
      key={ShortId.generate()}
      isDirty={props.isDirty}
      transportationPath={`/service-request/${props.serviceRequestId}/transportation`}
      editPath={`/service-request/${props.serviceRequestId}`}
      historyPath={`/service-request-history/${props.serviceRequestId}`}
      discussion={{
        ...props.discussion,
        iconOnly: true,
        serviceRequestId: props.serviceRequestId
      }}
      changeHistoryPath={props.changeHistoryPath}
      discussionPath={props.discussionPath}
    />
  );
};

PageLinks.propTypes = {
  serviceRequestId: PropTypes.string,
  changeHistoryPath: PropTypes.string,
  isDirty: PropTypes.bool,
  discussion: PropTypes.object,
  isTransportation: PropTypes.bool,
  discussionPath: PropTypes.string,
};
